export default "__VITE_ASSET__1027181a__"